import api from '../api';

export default {
    async getDataStatus(accessToken) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.get(`/portal/progress/weekly-summary`,  {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao carregar os dados do status:', error);
                throw error;
        }
    },

}

